const firebaseConfig = {
  apiKey: 'AIzaSyB1FI87qdJUDyHRP8sZTuSbOpfD9Fv8G_E',
  authDomain: 'simple-biz-app.firebaseapp.com',
  projectId: 'simple-biz-app',
  storageBucket: 'simple-biz-app.appspot.com',
  messagingSenderId: '168574264567',
  appId: '1:168574264567:web:c3d1105732948875dd5ff2',
};

export default firebaseConfig
